import React from 'react'
import { connect } from 'react-redux'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Badge, Btn, ConfirmDialog, DateTime, ThreeDots } from '../../../../../components'
import { tableCellCentered } from '../../../../../assets/js/styles'
import { gray, verde } from '../../../../../assets/js/colors'
import { getEmpresas } from '../../../../../services/localstorage/localstorage.service'
import useIntegrationsSection from './IntegrationsSectionHook'
import IntegrationFormModal from './IntegrationFormModal'
import CredentialsModal from './CredentialsModal'
import GeneratedTokenModal from './GeneratedTokenModal'
import { CONFIG_FIELD_LABELS, INTEGRATION_PARTNERS, partnerLabel } from './integrationPartners'

// Seção "Integrações via API (v1)" da aba Integrações do cadastro do TP: parceiros que
// acessam a API do TP Manager com token próprio (Frigol, Compel...). Só para usuários de
// sistema, como o restante do cadastro do TP.
function IntegrationsSection({ tpId, operationsCenters, users, dispatch }) {
  const { state, localDispatch, availablePartners, credentialsIntegration } =
    useIntegrationsSection(tpId, dispatch)

  const options = {
    // Empresas do usuário logado (as mesmas que ele vê no portal); o backend valida igual
    company_id: getEmpresas().map(c => ({ id: c.id, name: c.name })),
    operationcenter_id: (operationsCenters || []).map(o => ({ id: o.id, name: o.name })),
    file_type_id: (state.fileTypes || []).map(f => ({ id: f.id, name: f.name })),
    user_id: (users || []).map(u => ({ id: u.id, name: u.name })),
  }

  const configSummary = integration => {
    const partner = INTEGRATION_PARTNERS.find(p => p.value === integration.partner)
    if (!partner) return ''
    // Um campo por linha: a tabela fica dentro do modal do TP, que é estreito
    return partner.fields.map(field => {
      const id = integration.config[field]
      const option = options[field].find(o => o.id === id)
      return (
        <div key={field} style={{ fontSize: '0.85rem' }}>
          <span style={{ color: gray }}>{CONFIG_FIELD_LABELS[field]}:</span>{' '}
          {option ? option.name : `#${id}`}
        </div>
      )
    })
  }

  const actions = integration => ['Editar', 'Tokens', integration.active ? 'Desativar' : 'Ativar']

  const onActionClicked = (item, integration) => {
    if (item === 'Editar') localDispatch.onEditClicked(integration)
    else if (item === 'Tokens') localDispatch.onCredentialsClicked(integration)
    else localDispatch.onToggleActiveClicked(integration)
  }

  return (
    <>
      <div className="p-col-12">
        <p style={{ color: '#14B0BF', display: 'block' }}>Integrações via API (v1)</p>
      </div>
      <div className="p-col-12">
        <Btn onClick={localDispatch.onNewClicked} disabled={!availablePartners.length}>
          Nova integração
        </Btn>
      </div>
      <div className="p-col-12">
        <DataTable
          value={state.integrations}
          emptyMessage="Nenhuma integração via API para este TP"
        >
          <Column
            header="Parceiro"
            style={tableCellCentered(100)}
            body={i => (
              <>
                <div>{partnerLabel(i.partner)}</div>
                <Badge color={i.active ? verde : gray}>{i.active ? 'Ativa' : 'Inativa'}</Badge>
              </>
            )}
          />
          <Column header="Configuração" body={configSummary} />
          <Column header="Tokens" field="active_credentials" style={tableCellCentered(65)} />
          <Column
            header="Último uso"
            style={tableCellCentered(105)}
            body={i => (i.last_used_at ? <DateTime>{i.last_used_at}</DateTime> : '-')}
          />
          <Column
            header=""
            style={tableCellCentered(50)}
            body={i => <ThreeDots items={actions(i)} onClick={item => onActionClicked(item, i)} />}
          />
        </DataTable>
      </div>

      <IntegrationFormModal
        show={state.formModal.show}
        integration={state.formModal.integration}
        availablePartners={availablePartners}
        options={options}
        onSave={localDispatch.onFormSaved}
        onClose={localDispatch.onFormClosed}
      />
      <CredentialsModal
        integration={credentialsIntegration}
        onGenerate={localDispatch.onGenerateCredential}
        onRevoke={localDispatch.onRevokeCredential}
        onClose={localDispatch.onCredentialsClosed}
      />
      <GeneratedTokenModal
        token={state.generatedToken}
        onCopy={localDispatch.onCopyToken}
        onClose={localDispatch.onGeneratedTokenClosed}
      />
      <ConfirmDialog
        title={state.confirm ? state.confirm.title : ''}
        isVisible={!!state.confirm}
        content={state.confirm ? state.confirm.content : ''}
        okLabel="CONFIRMAR"
        onOk={localDispatch.onConfirmOk}
        onCancelar={localDispatch.onConfirmCancel}
      />
    </>
  )
}

export default connect()(IntegrationsSection)
